import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Toast
import { toast } from 'react-toastify';

// Components
import ConfirmModal from '../confirm-modal';
import EditModal from './illegal-plugin-modal';

// MUI Components
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const IllegalPlugins = () => {

    const [ illegalPlugins, setIllegalPlugins ]                     = useState([]);
    const [ confirmDeletePluginOpen, setConfirmDeletePluginOpen ]   = useState(false);
    const [ confirmDeletePluginId, setConfirmDeletePluginId ]       = useState(null);
    const [ editPlugin, setEditPlugin ]                             = useState({
        id: null,
        name: '',
        slug: '',
        reason: '',
    });

    const getIllegalPlugins = () => {
        axios.get('/restricted-plugins-for-editing').then(response => {
            setIllegalPlugins(response.data.plugins);
        });
    }

    const deletePlugin = (id) => {
        setConfirmDeletePluginOpen(true);
        setConfirmDeletePluginId(id);
    }

    const confirmDeletePlugin = () => {
        setConfirmDeletePluginOpen(false);
        axios.post(`/restricted-plugin/${confirmDeletePluginId}/delete`).then(response => {
            if( response.data.success ){
                toast.success('Plugin removed successfully');
                getIllegalPlugins();
            }
            else{
                toast.error(response.data.message);
            }
        });
    }

    useEffect(() => {
        getIllegalPlugins();
    }, []);

    return (
        <Box className='illegal-plugins-container'>
            <ConfirmModal 
                open={confirmDeletePluginOpen} 
                setOpen={setConfirmDeletePluginOpen} 
                title='Delete Plugin' 
                message='Are you sure you want to delete this plugin?' 
                onConfirm={() => confirmDeletePlugin(confirmDeletePluginId)} 
                onCancel={() => setConfirmDeletePluginOpen(false)} 
            />
            <EditModal 
                plugin={editPlugin}
                setPlugin={setEditPlugin}
                clearPlugin={() => {
                    setEditPlugin({
                        id: null,
                        name: '',
                        slug: '',
                        reason: '',
                    });
                    getIllegalPlugins();
                }}
            />
            <Box className='table-actions-bar'>
                <Button variant='contained' color='primary' onClick={() => setEditPlugin({
                    id: 'new',
                    name: '',
                    slug: '',
                    reason: '',
                })}>Add Plugin</Button>
            </Box>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Slug</TableCell>
                        <TableCell>Reason</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {illegalPlugins.map((plugin) => (
                        <TableRow key={plugin.id}>
                            <TableCell>{plugin.name}</TableCell>
                            <TableCell>{plugin.slug}</TableCell>
                            <TableCell>{plugin.reason}</TableCell>
                            <TableCell>
                                <Box className='actions-cell'>
                                    <Button variant='text' color='error' onClick={() => deletePlugin(plugin.id)}>
                                        <DeleteIcon />
                                    </Button>
                                    <Button variant='text' color='primary' onClick={() => setEditPlugin(plugin)}>
                                        <EditIcon />
                                    </Button>
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );

}

export default IllegalPlugins;